import { gql } from '@parkchirp/api-client';

export const ADD_TENANT_TO_SUBSCRIPTION = gql`
    mutation addTenantToSubscription(
        $email: String!,
        $subscriptionId: String!,
        $tenantSubscriptionId: String
    ) {
        addTenantToSubscription(
            email: $email,
            subscriptionId: $subscriptionId
            tenantSubscriptionId: $tenantSubscriptionId
        ) {
            id
        }
    }
`;

export const REMOVE_TENANT_FROM_SUBSCRIPTION = gql`
    mutation removeTenantFromSubscription(
        $email: String!,
        $subscriptionId: String!,
        $tenantSubscriptionId: String
    ) {
        removeTenantFromSubscription(
            email: $email,
            subscriptionId: $subscriptionId,
            tenantSubscriptionId: $tenantSubscriptionId
        )
    }
`;
